import { useCallback } from "react";
import { useAuthenticationContext } from "../../context/authenticationContext/authenticationContext";
import { useAdminController } from "../useAdminController/useAdminController";

export interface ISBEntityResizeResult {
  name: string;
  maxSizeInMegabytes: number;
}

export const useSBEntityResizer = (): [
  ISBEntityResizeResult | undefined,
  boolean,
  Error | undefined,
  (
    topic: string,
    queue: string,
    maxSizeInMB: number
  ) => Promise<ISBEntityResizeResult>
] => {
  const { user } = useAuthenticationContext();
  const { patch, response, loading, error } =
    useAdminController<ISBEntityResizeResult>(user!, false);

  const resize = useCallback(
    async (topic: string, queue: string, maxSizeInMB: number) => {
      var endpoint = `maxSize?maxSizeInMB=${maxSizeInMB}`;
      if (topic !== "") {
        endpoint += `&topic=${topic}`;
      } else {
        endpoint += `&queue=${queue}`;
      }

      let result = await patch(endpoint);
      return result;
    },
    [patch]
  );

  return [response.data, loading, error, resize];
};
